// frontend/src/App.js
import React, { useState } from "react";
import axios from "axios";
import LoadingOverlay from './LoadingOverlay';

import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";

const AstrologyForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    dateOfBirth: "",
    timeOfBirth: "",
    placeOfBirth: "",
    janmaNakshatra: "",
    janmaGotra: "",
    rashi: "",
    query: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/submit-query`, formData, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY
        }
      });
      alert(response.data.message);
      setFormData({
        name: "",
        dateOfBirth: "",
        timeOfBirth: "",
        placeOfBirth: "",
        janmaNakshatra: "",
        janmaGotra: "",
        rashi: "",
        query: "",
      });
    } catch (error) {
      alert("Failed to submit the query");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container maxWidth="sm" sx={{ mt: 5, p: 3, boxShadow: 3, borderRadius: 2, position: 'relative' }}>
      <LoadingOverlay open={loading} message="Submitting astrology query..." />
      <Typography variant="h4" gutterBottom textAlign="center">
        Astrology Query Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Date of Birth"
          name="dateOfBirth"
          type="date"
          value={formData.dateOfBirth}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          label="Time of Birth"
          name="timeOfBirth"
          type="time"
          value={formData.timeOfBirth}
          onChange={handleChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          label="Place of Birth"
          name="placeOfBirth"
          value={formData.placeOfBirth}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Janma Nakshatra"
          name="janmaNakshatra"
          value={formData.janmaNakshatra}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Janma Gotra"
          name="janmaGotra"
          value={formData.janmaGotra}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Rashi"
          name="rashi"
          value={formData.rashi}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Query"
          name="query"
          value={formData.query}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          rows={4}
          required
        />
        <Box textAlign="center" mt={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default AstrologyForm;
